import React from 'react';
import {UpdateAdminNotesProvider} from '../contexts/UpdateAdminNotesContext';
import UpdateAdminNotes from './UpdateAdminNotes';
import {UpdateIncomeProvider} from '../contexts/UpdateIncomeContext';
import UpdateIncome from './UpdateIncome';
import {UpdateTamalProvider} from '../contexts/UpdateTamalContext';
import UpdateTamal from './UpdateTamal';
import styles from './styles.module.scss';

export function TopCards() {

  return (
    <div className={styles.topCards}>
      <UpdateAdminNotesProvider>
        <UpdateAdminNotes/>
      </UpdateAdminNotesProvider>
      <div className={'w-50'}>
        <UpdateTamalProvider>
          <UpdateTamal/>
        </UpdateTamalProvider>
        <UpdateIncomeProvider>
          <UpdateIncome/>
        </UpdateIncomeProvider>
      </div>
    </div>
  );
}
